export const instanceGuard = <T>(instance: T): T => {
    if (!instance) {
        throw new Error('Instance is unavailable. Are you sure createInstance was called?');
    }

    return instance;
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/core/utils/services/index.ts